import { render, staticRenderFns } from "./OwalHeaderBanner.vue?vue&type=template&id=1486aa2e&scoped=true"
import script from "./OwalHeaderBanner.vue?vue&type=script&lang=js"
export * from "./OwalHeaderBanner.vue?vue&type=script&lang=js"
import style0 from "./OwalHeaderBanner.vue?vue&type=style&index=0&id=1486aa2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1486aa2e",
  null
  
)

export default component.exports